module.exports = __webpack_public_path__ + "static/Gregory_Schwartz-876760cd6897ef4259bc6f6ef0b74211.png";